export var DocsBlockImagePropertyAspectRatio;
(function (DocsBlockImagePropertyAspectRatio) {
    /** Default. Automatic aspect ratio */
    DocsBlockImagePropertyAspectRatio["auto"] = "Auto";
    /** 1:1 aspect ratio */
    DocsBlockImagePropertyAspectRatio["square"] = "Square";
    /** 3:2 aspect ratio */
    DocsBlockImagePropertyAspectRatio["landscape"] = "Landscape";
    /** 2:3 aspect ratio */
    DocsBlockImagePropertyAspectRatio["portrait"] = "Portrait";
    /** 16:9 aspect ratio */
    DocsBlockImagePropertyAspectRatio["wide"] = "Wide";
})(DocsBlockImagePropertyAspectRatio || (DocsBlockImagePropertyAspectRatio = {}));
